module.exports = __webpack_public_path__ + "static/media/whoHome.7c3267b0.jpg";